import { isAbortOrCancelError } from '@/shared/lib/is-abort-or-cancel-error'

const TRANSPORT_TYPE_ERROR_FRAGMENTS = [
  'network error',
  'failed to fetch',
  'networkerror',
  'load failed',
  'connection was lost',
] as const

export function isResumableSseTransportError(error: unknown): boolean {
  if (isAbortOrCancelError(error) || !(error instanceof TypeError)) {
    return false
  }

  const message = error.message.toLowerCase()
  return TRANSPORT_TYPE_ERROR_FRAGMENTS.some((fragment) =>
    message.includes(fragment)
  )
}
